import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { MutationStatusResponse, IMutation } from 'src/app/core/domain/mutation';
import { environment } from 'src/environments/environment';
import { LoadingService } from 'src/app/core/services/loading.service';
import { AppInsightsService } from 'src/app/core/services/app-insights.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { ApiRoutingPolicyService } from 'src/app/core/services/api-routing-policy.service';

@Injectable({
  providedIn: 'root'
})
export class MutationService {

  private baseUrl = environment.apiUrl;

  private http = inject(HttpClient);
  private loadingService = inject(LoadingService);
  private appInsightsService = inject(AppInsightsService);
  private errorHandlerService = inject(ErrorHandlerService);
  private apiRoutingPolicyService = inject(ApiRoutingPolicyService);

  constructor() {}

  /**
   * Fetches the latest mutation process status for a given patient
   * NOTE: mutations-status uses 'patients' domain (it's a patient sub-resource)
   */
  getMutationStatus(rettxid: string): Observable<MutationStatusResponse> {
    // mutations-status is a patient sub-resource, so we use 'patients' domain
    const url = this.apiRoutingPolicyService.buildUrl('patients', '/' + rettxid + '/mutations-status');
    return this.http.get<MutationStatusResponse>(url).pipe(
      tap(response => {
        //console.log('Mutation status response:', response);
      }),
      catchError(
        this.errorHandlerService.handleError(
          'MutationService::getMutationStatus',
          'CONTROL_MESSAGES.ERROR.GET_MUTATION_STATUS',
          'patients',  // Note: using 'patients' domain for telemetry
          this.apiRoutingPolicyService.getTelemetryContext('patients')
        )
      )
    );
  }

  /**
   * Get all mutations for a given patient
   * NOTE: mutations list uses 'mutations' domain
   */
  getAllMutations(rettxid: string): Observable<IMutation[]> {
    this.loadingService.show();
    // mutations list uses 'mutations' domain
    const url = this.apiRoutingPolicyService.buildUrl('mutations', '/' + rettxid + '/mutations');

    return this.http.get<any>(url).pipe(
      tap(response => {
        //this.appInsightsService.trackTrace(`User fetched all mutations for patient ${rettxid}`);
        //console.log('All mutations response:', response);
      }),
      catchError(
        this.errorHandlerService.handleError('MutationService::getAllMutations', 'CONTROL_MESSAGES.ERROR.GET_ALL_MUTATIONS', 'mutations', this.apiRoutingPolicyService.getTelemetryContext('mutations'))
      ),
      finalize(
        () => this.loadingService.hide()
      )
    );
  }
}